import React, { useEffect } from "react";
import { StepId } from "../../enums/navigation";
import { useNavigateStore } from "../../stepFlowHooks/useNavigateStore";
import { useAuthStatusStore } from "../../stepFlowHooks/useAuthStatusStore";
import { AuthStatus } from "../../enums";

interface StepFlowGateProps {
    isCompleted: boolean;
    completedStepId: StepId;
}

export const StepFlowGate = ({
    isCompleted,
    completedStepId,
}: StepFlowGateProps) => {
    const navigateTo = useNavigateStore((store) => store.navigateTo);
    const authStatus = useAuthStatusStore((store) => store.authStatus);

    useEffect(() => {
        if (!isCompleted) {
            return;
        }

        switch (completedStepId) {
            case StepId.INIT:
                navigateTo(
                    authStatus === AuthStatus.SIGNED_IN
                        ? StepId.POST_SIGN_IN
                        : StepId.SIGN_IN
                );
                break;
            case StepId.SIGN_IN:
                // Sign-in page navigates to external authenticator page and will redirect back.
                break;
            case StepId.POST_SIGN_IN:
                navigateTo(StepId.PRE_STREAMING);
                break;
            case StepId.PRE_STREAMING:
                navigateTo(StepId.STREAMING);
                break;
            case StepId.STREAMING:
                // It will use hook (useNavigateStore) to navigate to StepId.POST_STREAMING once the session is terminated
                break;
            case StepId.POST_STREAMING:
                // It will navigate to external IdP/IdC dashboard or show a modal
                break;
            default:
                navigateTo(StepId.INIT);
        }
    }, [isCompleted, completedStepId]);

    // Will be navigated to a step on `Navigator` component.
    return <></>;
};
